import {HttpClient} from './httpClient'; 
import {submitEventMapper, filerEventMapper, resettingJobEventMapper, resettingJobDocType} from '../util/handleStates'
import _ from 'lodash';
import { pgaHumanNames } from '../CBP_App/formSections/pga/constantsPGA'
import { confirmAlert } from 'react-confirm-alert';
import React from 'react'
import { getQueryVariable } from './jobInfo';

export const fileAction = (shipId,docType,fileProd, formType) => {
  const shipmentCountry = window.shipmentCountry || "US";
  let eventType = "FILE_CBSA_EDI_RECORDS"
  if(formType === "CARM"){
    eventType = "FILE_CARM_CAD";
  }
  switch(shipmentCountry) {
    case 'US' :
        return fileUSAction(shipId)
    case 'CA' :
        return fileCAAction(shipId,docType,fileProd, eventType)
    case 'GB' :
      return fileUKAction(shipId, fileProd)    
  }
};


export const mockingPrtResponseApi  = (eventMessage) => {
  let body = {
    eventMessage: eventMessage,
    eventType: 'MOCK_HMRC_PRINT_RESPONSE',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}
export const filePscAction = (shipId, docType, createPSC) => {
  let body = {
    eventMessage: {
      "type": docType,
      "createPSC": createPSC,
      "shipmentid": shipId
    },
    eventType: 'FILE_ENTRY_SUMMARY_FORM',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
};

export const fileUKAction = (shipId, fileProd) => {
  let body = {
    eventMessage: {
      shipmentid: shipId
    },
    eventType: 'FILE_C88_SUMMARY_FORM',
    eventTime: Date.now()
  };
  if(fileProd){
    body.eventMessage.fileWithHMRC = 1
  }
  return HttpClient.custom({
    data: body,
  })
}

export const fileUSAction = (shipId) => {
   let body = {
     eventMessage: {
       shipmentid: shipId
     },
     eventType: 'FILE_ENTRY_SUMMARY_FORM',
     eventTime: Date.now()
   };
   return HttpClient.custom({
     data: body,
   })
};
export const fileCAAction = (shipId,docType,fileProd, eventType="FILE_CBSA_EDI_RECORD") => {
   let body = {
     eventMessage: {
       shipmentid: shipId,
       useCBSAEnvironment : fileProd,
       CBSAEDIFormat:docType
     },
     eventType,
     eventTime: Date.now()
   };

   if(window.shipmentMode==='LVS_SHIPMENTS'){
    body.eventMessage.isLvs=true
  }
  else body.eventMessage.isLvs=false
   
   return HttpClient.custom({
     data: body,
   })
};


export const setAggregationView = (shipmentId, setAggregatedBoolean) => {
  let body = {
    "eventMessage": {
      "shipmentId": shipmentId,
      "useAggregated": setAggregatedBoolean ? "true" : "false"
    },
    "eventType": "SET_AGGREGATION_VIEW",
    "eventTime": Date.now()
  }


  return HttpClient.custom({
    data: body,
  });
};

export const pscSubmitEntrySummaryForm = (shipmentID, docType, createPSC) => {

  const shipmentCountry = window.shipmentCountry || "US";
  let data = {
      eventMessage: {
        "type": docType,
        "createPSC": createPSC,
        "shipmentid": shipmentID
      },
      eventType: submitEventMapper[shipmentCountry]["submitEvent"],
      eventTime: Date.now()
    };

  return HttpClient.custom({
    data
  });
}

export const submitEntrySummaryForm = (shipmentID, docType, isChildShipment, formType) => {
  const shipmentCountry = window.shipmentCountry || "US";
  let data = null;
  if (shipmentCountry === "CA"){
    data = {
      eventMessage: {
        shipmentid: shipmentID,
        CBSAEDIFormat: docType

      },
      eventType: submitEventMapper[shipmentCountry]["submitEvent"],
      eventTime: Date.now()
    };
    if(window.shipmentMode==='LVS_SHIPMENTS' && !isChildShipment){
      data.eventMessage.isLvs=true
    }
    else{
      data.eventMessage.isLvs=false
    } 
    if(window.shipmentMode==='LVS_SHIPMENTS'){
      data.eventMessage.isLvsChild = (isChildShipment === true)
    }else{
      data.eventMessage.isLvsChild = false
    }
    if(formType==="CARM"){
      data.eventMessage.cbsaFormType = formType
    }
}
  else {
    data = {
      eventMessage: {shipmentid: shipmentID},
      eventType: submitEventMapper[shipmentCountry]["submitEvent"],
      eventTime: Date.now()
    };
  }
  return HttpClient.custom({
    data
  });
}

export const retractESForm = (shipId,docType="", st) => {
  let filerEvent = "FILE_ENTRY_SUMMARY_FORM";
  if(window.shipmentCountry === "CA"){
    filerEvent = "FILE_CBSA_EDI_RECORDS"
  }
  let body = {
    "eventMessage": {
      "shipmentid": shipId,
      "action": "DELETE",
      "type": docType
    },
    "eventType": filerEvent,
    "eventTime": Date.now()
  };
  if(docType === 'DOC_ENTRY_3461'){
    body.eventMessage["deleteCbpDocumentInfo"] = {
        "reasonCode": st.retractReason,
        "referenceDataType": st.referenceDataType,
        "referenceDataNumber": st.referenceDataNumber
    }
  }
  return HttpClient.custom({
    data: body,
  })
};


export const cargoReleaseStandalone = (shipmentId, eventType) =>{
  let data = {
    "eventMessage": {
      "shipmentid": shipmentId,
          "type": "DOC_ENTRY_3461",
          "action": "REPLACE",
          "isStandaloneCr": true
    },
    "eventType": eventType,
    "eventTime": Date.now()
  }
  return HttpClient.custom({
    data
  });
}

export const pgaUpdateSubmit = (shipmentData) => {
  let formTypeToProgramName = {};
  (shipmentData.DropDownValues.allVoluntaryPGAs||[]).map(programx=>
    (programx.programDetails||[]).map(oneFormType=> {
      formTypeToProgramName[oneFormType.formType] = programx.programName;
    })
  );
  let updateInfoList  = _.get(shipmentData,"EntryTypeInfo.linePgaUpdateInfo.pgaUpdateInfos",[]).filter(a=>a.status=="checked");
  let allowedPrograms = [];
  (updateInfoList||[]).map(updateI=>allowedPrograms.push(formTypeToProgramName[updateI.formType]))


  let getHTSByMerchandiseId = (myMerchandiseId)=>{
    for(let myinvoice of shipmentData?.DescriptionOfMerchandise?.entrySummaryInvoices){
      for(let mymerchandise of myinvoice.merchandiseLineItems){
        if(mymerchandise.merchandiseId ==myMerchandiseId){
          let htsesappended =mymerchandise.merchandiseDuties.sort((a,b)=>a.isCommodityDuty-b.isCommodityDuty).map(a=>a.htsus).join(",");
          return htsesappended;
        }
      }
    }
    return "";
  }
  let getMerchandiseIndexByMerchandiseId = (myMerchandiseId)=>{
    let invoiceIndex = 0;
    for(let myinvoice of shipmentData?.DescriptionOfMerchandise?.entrySummaryInvoices){
      invoiceIndex++;
      let merchandiseIndex = 0;
      for(let mymerchandise of myinvoice.merchandiseLineItems){
        merchandiseIndex++;
        if(mymerchandise.merchandiseId ==myMerchandiseId){
          return {merchandiseIndex,invoiceIndex}
        }
      }
    }
  }
  

  let allCheckedMerchandises = _.uniq(updateInfoList.map(a=>a.merchandiseId))
  let updateInfoListWithAllPGAsForMerch = [];
  for (let myinvoice of shipmentData?.DescriptionOfMerchandise?.entrySummaryInvoices) {
    for (let mymerchandise of myinvoice.merchandiseLineItems) {
      if (allCheckedMerchandises.includes(mymerchandise.merchandiseId)) {
        for (let oneFlag of mymerchandise.pgaFlagInfos.filter(b=>allowedPrograms.includes(formTypeToProgramName[b.formType]))) {
          updateInfoListWithAllPGAsForMerch.push({

            formType: oneFlag.formType,
            merchandiseId: mymerchandise.merchandiseId,
            pgaGuid: oneFlag.pgaGuid,
            status: "checked"
          })
        }
      }
    }
  }
  
  let updateInfoMassaged = {};
  let pgalist = []

  for(let oneInfo of updateInfoListWithAllPGAsForMerch.filter(a=>a.status=='checked')){
    updateInfoMassaged[oneInfo.merchandiseId] = updateInfoMassaged[oneInfo.merchandiseId] || {pgaTypes:[],pgaGuids:[]};;
    if(oneInfo.status=="checked"){
      let indexesxx = getMerchandiseIndexByMerchandiseId(oneInfo.merchandiseId);
      pgalist.push(`Invoice ${indexesxx?.invoiceIndex} line ${indexesxx?.merchandiseIndex}: ${oneInfo.formType.replaceAll("_"," ")}
        ${pgaHumanNames[oneInfo.formType]?'('+pgaHumanNames[oneInfo.formType]+')':''}
        `);
      updateInfoMassaged[oneInfo.merchandiseId].pgaTypes.push(oneInfo.formType)
      updateInfoMassaged[oneInfo.merchandiseId].pgaGuids.push((oneInfo.pgaGuid+"").indexOf("FAKEGUID_")>=0?null:oneInfo.pgaGuid)
    }
  }
  
  if(pgalist.length == 0){
    alert("No correcting PGAs detected!");
    console.error("No correcting PGAs detected!",shipmentData)
    return;
  }
  let updatePGAInfos = [];
  for(let oneMerchandiseId of Object.keys(updateInfoMassaged) ){
    updatePGAInfos.push({
      "merchandiseId": oneMerchandiseId,
      "pgaHtsCodes": [
          {
              "htsCode": (getHTSByMerchandiseId(oneMerchandiseId)+"").replaceAll(".",""),
              ...updateInfoMassaged[oneMerchandiseId]
          }
      ]

    })
  }
  if(!shipmentData.FormValues.shipmentId){
    alert("warning missing shipmentid!")
  }
    let body = {
      "eventMessage": {
          "shipmentid": shipmentData.FormValues.shipmentId,
          "updateCbpDocumentPGAInfo": {
              "updatePGAInfos": updatePGAInfos
          },
          "type": "DOC_PGA_UPDATE",
          "action": "UPDATE"
      },
      "eventType": "SUBMIT_PGA_UPDATE",
      "eventTime": Date.now()
  }
  
  //``,
  confirmAlert({
    closeOnClickOutside: true,
    overlayClassName: 'bigConfirmAlert',
    title: <span>File PGA correction for these PGAs:<br/>
      {pgalist.map((axxxx,ixxxx)=><small style={{paddingLeft:'10px'}} key={axxxx+"abc123"}>{axxxx.trim()}{ixxxx==pgalist.length-1?'':','}<br/></small>)}
      </span>,
    buttons: [
      {
        label: "Cancel",
        onClick: () => {
        }
      },
      {
        label: "Confirm",
        onClick: () => {
          window.GLOBAL_PGA_UPDATE_IN_PROGRESS= true;
          document.getElementById("RERENDER__BUTTONS") &&document.getElementById("RERENDER__BUTTONS").click();
          setTimeout(()=>{
            window.GLOBAL_PGA_UPDATE_IN_PROGRESS=false
            document.getElementById("RERENDER__BUTTONS") &&document.getElementById("RERENDER__BUTTONS").click();
          },10000)
  
          HttpClient.custom({
            data: body,
          }).then((responsekk)=>{
            console.log('responsekk: ', responsekk);
            body.eventType = "FILE_PGA_UPDATE"
            
            HttpClient.custom({
              data: body,
            }).then((responsekkx)=>{
              let errorMsg = _.get(responsekkx,"data.eventMessage.errorMsg");
              let successmessage = _.get(responsekkx,"data.eventMessage.fieldmessage[0].fieldmessage")+"";
              if(errorMsg){
                alert(`${_.get(responsekkx,"data.eventMessage.resultOfOperation")}${errorMsg?": "+errorMsg:""}`)
              } else {
                alert(successmessage)
              }
              setTimeout(()=>{
                document.querySelector(".broker-card.active.selected") && document.querySelector(".broker-card.active.selected").click()
              },500)
            });
        
          })
        }
      }
    ]
  })
};

export const resettingJob = (shipmentId, docType, amendmentReasons, otherattributes) => {
  let body = {
    "eventMessage": {
      "shipmentid": shipmentId
  },
  "eventType": resettingJobEventMapper[window.shipmentCountry]['resetJobEvent'],
  "eventTime": Date.now()
  }
  if(docType){
    body.eventMessage.type = docType;
  }
  if(docType == "DOC_PGA_UPDATE"){
    body.eventMessage.updatePGA = 1;
  }
  if(amendmentReasons){
    body.eventMessage.amendmentReasons = {
      "value": amendmentReasons
    }
  }
  if(otherattributes){
    body.eventMessage = {...body.eventMessage,...otherattributes}
  }
  return HttpClient.custom({
    data: body,
  })
};

export const createArticleSetFromExistingLineItem = (shipmentId, invoiceId, articleSet, refershESForm) => {
  let body = {
    "eventType": "CREATE_ARTICLE_SET",
    "eventTime": Date.now(),
    "eventMessage": {
      "descriptionOfMerchandise": {
        "entrySummaryInvoices": [
          {
              "shipmentId": shipmentId,
              "invoiceId": invoiceId,
              "merchandiseLineItems": [
                {
                  "merchandiseId": articleSet.articleHeaderX,
                  "articleSubComponent": articleSet.articleHeaderV,
                  "merchandiseDuties": [
                    {
                     "htsus": (articleSet.htsus) ? (articleSet.htsus).replace(/\./g, ""): ''
                    }
                  ]
                }
              ]
          }
      ]
      },
      "shipmentId": shipmentId
    }
  }
  
  return HttpClient.custom({
    data: body,
  }).then((res)=>{
    refershESForm()
  })
};

export const startPSC = (shipmentId) => {
  let body = {
    "eventMessage": {
      "shipmentid": shipmentId,
      "type": "DOC_ENTRY_7501",
      "createPSC": 1
  },
  "eventType": resettingJobEventMapper[window.shipmentCountry]['resetJobEvent'],
  "eventTime": Date.now()
  }
  return HttpClient.custom({
    data: body,
  })
};

export const updateWorkFlow = (shipmentId, statusType, isLvs) => {
  let body = {
    "eventMessage": {
      "entity": {
        "entityId": shipmentId,
        "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
      },
      "country":window?.shipmentCountry === 'CA' ? window?.shipmentCountry: undefined,
      "event": statusType,
    },
    "eventType": "UPDATE_WORKFLOW",
    "eventTime": Date.now()
  };
  if(isLvs){
    body.eventMessage.isLvs = true;
  }
  return HttpClient.custom({
    data: body,
  })
};

export const updateCadVersion = (shipmentId) => {
  let body = {
    "eventMessage": {
      shipmentId
    },
    "eventType": "UPDATE_CAD_VERSION",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
};

export const initalizeBhHouseJob = (shipmentId, brokerAssigned) => {
  let body = {
    "eventMessage":  {
      "shipmentId": shipmentId,
      "brokerAssigned": brokerAssigned,
    },
    "eventTime": Date.now(),
    "eventType": "INITIALIZE_ENTRY_SUMMARY_FORM",
  }
  return HttpClient.custom({
    data: body,
  })
}

export const startBhHouseJob = (shipmentId, bhHouse, kxId, comment = "Updated from UI") => {
  let body = {
    "eventMessage": {
      "entity": {
        "entityId": shipmentId,
        "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
      },
      "event": bhHouse,
      "comment": comment,
      "brokerAssigned":kxId,
      "receivingTime": Date.now(),
      "country":window?.shipmentCountry === 'CA' ? window?.shipmentCountry: undefined,
    },
    "eventType": "UPDATE_WORKFLOW",
    "eventTime": Date.now()
  };
  if(window.shipmentMode === 'LVS_SHIPMENTS'){
    body.eventMessage.isLvs = true;
  }
  return HttpClient.custom({
    data: body,
  })
};


export const entryNumberEdit = (shipmentId, epu, hmrc, date, epoch) => {
  let data = {
      eventMessage: {
        "shipmentId": shipmentId,
        "entryNumber": epu + '-' + hmrc + '-' + date,
        "entryDate": epoch,
        "epu": epu,
        "hmrcEntryNumber": hmrc
      },
      eventType: "SAVE_C88_FORM_UK",
      eventTime: Date.now(),
  }
  return HttpClient.custom({
    data
  })
};

export const updateShipmentStatus = (event, shipmentId, user) => {
  let data = {
      eventMessage: {
        "event": event,
        "comment": "Updated from broker update entrynumber and state modal",
        "user": user,
        "entity": {
          "entityId": shipmentId,
          "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
        },
        "brokerAssigned": user,
        "country":window?.shipmentCountry === 'CA' ? window?.shipmentCountry: undefined,
      },
      eventType: "UPDATE_WORKFLOW",
      eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
};

export const cancelC88ShipmentUK = (shipId , fileProdStatus)=>{
  let body = {
    "eventMessage": {
      
        "shipmentid": shipId,

    },
    "eventType": "CANCEL_C88_SHIPMENT_UK",
    "eventTime": Date.now()
  };

  if(fileProdStatus){
    body.eventMessage.fileWithHMRC = 1
  }
  return HttpClient.custom({
    data: body,
  })
}

export const mockediForCancellation = (shipId ,status)=>{
  let body = {
    "eventMessage": {
      
        "shipmentId": shipId,
        "status": status
     
   
    },
    "eventType": "MOCK_UK_EDI_RESPONSE",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}

export const bhSurrender = (shipmentId)=>{
  let body = {
    "eventMessage": {
      "entity": {
        "entityId": shipmentId,
        "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
      },
      "event": "BH_BROKER_SURRENDER",
      "assignedBHCode":"300",
      "receivingTime": Date.now(),
      "country":window?.shipmentCountry === 'CA' ? window?.shipmentCountry: undefined,
    },
    "eventType": "UPDATE_WORKFLOW",
    "eventTime": Date.now()
  };
  if(window.shipmentMode === 'LVS_SHIPMENTS'){
    body.eventMessage.isLvs = true;
  }
  return HttpClient.custom({
    data: body,
  })
}

export const isEU = (transactionCountry) => (["gb","nl","es","ca"].includes(transactionCountry?.toLowerCase())) 
export const languageSelectorCountries = (country) => (["nl","es"].includes(country?.toLowerCase())) 
export const isUS = (transactionCountry) => transactionCountry?.toLowerCase() === "us" 

export const searchCurrentJob = (shipId) => {
  if(getQueryVariable('onlyOneShipment') && getQueryVariable('shipmentHttpId')){

    const transactionCountry = getQueryVariable('transactionCountry')
    const eventTypeEngine = isEU(transactionCountry) ? `GET_${transactionCountry}_ENTRY_STATUS`: `GET_ENTRY_STATUS`
    
    const extraParams = isEU(transactionCountry) ? {
      transactionType: getQueryVariable('transactionType'),
      countryCode: transactionCountry,
    } : {}
    
    let data = {
      "eventMessage":{
        entryIds:[shipId || window.shipmentId ],
        ...extraParams
      },
      "eventType": eventTypeEngine,
      "eventTime": Date.now()
    }

    if (window.shipmentMode === 'LVS_SHIPMENTS') {
      data.eventMessage.isLvs = true
    }

    return HttpClient.custom({
      data,
    })

  }

  let data = {
    eventMessage: {
      searchType: "SEARCH_TYPE_BROKER",
      filters: [
        {
          "key":"SEARCH_FILTERS_SHIPMENT_ID",       
          "value":shipId||window.shipmentId
        }
      ]
    },
    eventType: window.shipmentMode === "TRANSIT_SHIPMENTS" ? "FETCH_TRANSIT_SHIPMENTS": "SEARCH_SHIPMENTS_BROKER",
    eventTime: Date.now()
  }
  if(window.shipmentMode === 'LVS_SHIPMENTS'){
    data.eventMessage.isLvs = true
  }
  return HttpClient.custom({
    data,
  })
}

export const searchJob = (shipId) => {
  let data = {
    eventMessage: {
      shipmentId: shipId,
    },
    eventType: "SEARCH_JOB",
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data,
  })
}

export const getErrorMessages = (callback = false, type) => {
  const dataSet = {
    "eventMessage": {
      "type": type
    }, "eventType": "GET_CBP_ERROR_LIST",
    "eventTime": 1540599191058
  };
  return HttpClient.custom({
    data: dataSet,
  })
    .then(response => {
      if (callback) callback(response.data);
      return response
    })
    .catch(err => {
      console.error('getErrorMessages ERROR:', err);
    })
};

export const getBOLValues = () => {
  const dataSet = {
    "eventType": "GET_CBP_NOTIFICATION_STATUS_LIST",
    "eventTime": Date.now(),
    "eventMessage": {"infoType": "CBP_ADVISORY_CARGO_RELEASE_DISPOSITION_BILL_MATCH"}
  };
  return HttpClient.custom({
    data: dataSet,
  })
};

export const getCRValues = () => {
  const dataSet = {
    "eventType": "GET_CBP_NOTIFICATION_STATUS_LIST",
    "eventTime": Date.now(),
    "eventMessage": {"infoType": "CBP_ADVISORY_CARGO_RELEASE_DISPOSITION_CODE"}
  };
  return HttpClient.custom({
    data: dataSet,
  })
};

export const getPGAValues = () => {
  const dataSet = {
    "eventType": "GET_CBP_NOTIFICATION_STATUS_LIST",
    "eventTime": Date.now(),
    "eventMessage": {"infoType": "CBP_ADVISORY_CARGO_RELEASE_DISPOSITION_PGA"}
  };
  return HttpClient.custom({
    data: dataSet,
  })
};

export const updateCRResponse = (shipId, responsecode, messagecode, epoch, comment, docType, action, BOL, CR, PGA) => {
  let dataSet;
  dataSet = {
    "eventMessage": {
      "shipmentid": shipId,
      "doctype": "DOC_CARGO_RELEASE_NOTIFICATION",
      "responsecode": "ACCEPTED",
      "messagecode": messagecode,
      "billMatch": BOL,
      "dispositionCode": CR,
      "PGADisposition": PGA,
      "timestamp": epoch,
      "comment": comment
    },
    "eventType": "SET_RESPONSE_MANUAL",
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: dataSet,
  })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error('updateResponse ERROR:', err);
    })
}
export const updateResponseUK = (shipmentId, responsecode,routeStatus) => {
  let payload = {
      "eventMessage": {
        "shipmentId": shipmentId,
        "status": responsecode,
        "roe":routeStatus

      },
      "eventType": "MOCK_UK_EDI_RESPONSE",
      "eventTime": Date.now()
    }
    return HttpClient.custom({
      data: payload,
    }).then(response => {
        return response
    }).catch(err => {
        console.error('updateResponse ERROR:', err);
    })
}

export const updateResponseCA = (shipmentId, responsecode, ediFormat) => {

  let payload="";
  let transCusdec = window.transactionNumber.toString();
  transCusdec = transCusdec.substring(5, transCusdec.length);
  if(ediFormat==="EDI_CUSDEC") {
     payload = {
      "eventMessage": {
        "shipmentId": shipmentId,
        "txnNumber": transCusdec,
        "ediFormat": ediFormat,
        "responseCode": responsecode

      },
      "eventType": "SEND_MOCK_CBSA_REQUEST",
      "eventTime": Date.now()
    }
  }

  else if(ediFormat === "EDI_CARM"){
    payload = {
      eventMessage: {
        responseType: responsecode,
        txnNumber: window.transactionNumber
      },
      eventType: "SEND_MOCK_CARM_REQUEST",
      eventTime: Date.now()
    }
  }
  
  else{
    payload = {
      "eventMessage": {
        "shipmentId": shipmentId,
        "txnNumber": window.transactionNumber,
        "ediFormat": ediFormat,
        "responseCode": responsecode

      },
      "eventType": "SEND_MOCK_CBSA_REQUEST",
      "eventTime": Date.now()
    }
  }
  return HttpClient.custom({
    data: payload,
  }).then(response => {
      return response
  }).catch(err => {
      console.error('updateResponse ERROR:', err);
  })
}
export const holdShipment = (shipId) => {
  let body = {
    "eventMessage": {
      "entity": {
        "entityId": shipId,
        "entityType": "WORKFLOW_ENTITY_TYPE_SHIPMENT"
      },
      "event": "ENTRY_ON_HOLD",
      "country":window?.shipmentCountry === 'CA' ? window?.shipmentCountry: undefined,
    },
    "eventType": "UPDATE_WORKFLOW",
    "eventTime": Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}

export const updateResponseWithCW = (shipId, responsecode, censusWarningCode, epoch, docType) => {
  let dataSet;
  docType = `${docType}_RESPONSE`;
   dataSet = {
      "eventMessage": {
        "shipmentid": shipId,
        "doctype": docType,
        "responsecode": responsecode,
        "censusWarningCode": censusWarningCode,
        "timestamp": epoch
      },
      "eventType": "SET_RESPONSE_MANUAL",
      "eventTime": Date.now() / 1000
    };
    return HttpClient.custom({
      data: dataSet,
    }).then(response => {
        return response
    }).catch(err => {
        console.error('updateResponse ERROR:', err);
    })
}
export const updateResponse = (shipId, responsecode, messagecode, epoch, comment, docType,  BOL, CR, PGA) => {
  let dataSet;
  docType = `${docType}_RESPONSE`
  if (responsecode !== 'ACCEPTED' && !responsecode.includes("RETRACT")) {
    dataSet = {
      "eventMessage": {
        "shipmentid": shipId,
        "doctype": docType,
        "responsecode": responsecode,
        "messagecode": messagecode,
        "timestamp": epoch,
        "comment": comment
      },
      "eventType": "SET_RESPONSE_MANUAL",
      "eventTime": Date.now() / 1000
    };
  } else {
    dataSet = {
      "eventMessage": {
        "shipmentid": shipId,
        "doctype": docType,
        "responsecode": responsecode,
        "timestamp": epoch,
        "comment": comment
      },
      "eventType": "SET_RESPONSE_MANUAL",
      "eventTime": Date.now() / 1000
    };
  }
  return HttpClient.custom({
    data: dataSet,
  })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error('updateResponse ERROR:', err);
    })
}

export const resetChildShipments = (shipmentId) => {
  let reqParams = {
      "eventMessage": {
          "shipmentid": shipmentId
      },
      "eventType": "UPDATE_STATES_FOR_CHILD_SHIPMENTS",
      "eventTime": Date.now() / 1000
  }
  return HttpClient.custom({
    data: reqParams,
  })
}

export const getAvailableOptions = (shipmentId) => {
  let reqParams = {
    "eventMessage": shipmentId,
    "eventType": "GET_AVAILABLE_UPDATE_OPTIONS",
    "eventTime": Date.now() / 1000
  }
  return HttpClient.custom({
    data: reqParams,
  })
}

export const sendToPSCChild = (eventType, childId)=>{
  let reqParams ={
    "eventType": eventType,
    "eventMessage": {
      "childId": childId,
    }
}
return HttpClient.custom({
  data: reqParams,
})
}

export const sendMsgToRocketChat = (shipmentId, klearEventType, userGuid) => {

 // KLEAR_CHAT_BROKER_PICKED = 13;  //Start Job
 // KLEAR_CHAT_BROKER_RETURN_TO_QUEUE = 14; //Back to pool

  let reqParams = {
    "eventMessage":{
      "shipmentId": shipmentId,
      "klearEventType": klearEventType,
      "userGuid": userGuid
    },
    "eventType": "SEND_MESSAGE_TO_ROCKET_CHAT",
    "eventTime": Date.now() / 1000
  }
  return HttpClient.custom({
    data: reqParams,
  })
}

export const CwUpdate = (shipId) => {
  let payload = {
    "eventMessage": {
        "shipmentid": shipId,
        "type": "DOC_CW_OVERRIDE",
        "overrideCW": 1
    },
    "eventType": "UPDATE_ENTRY_SUMMARY_STATE",
    "eventTime": Date.now() 
  }
  return HttpClient.custom({
    data: payload,
  })
}
export const CwOverride = (shipId, overrideCwInfos, evtType) => {
  let payload = {
    "eventMessage": {
      "shipmentid": shipId,
      "overrideCbpDocumentCwInfo": {
          "overrideCwInfos": overrideCwInfos
      },
      "type": "DOC_CW_OVERRIDE",
      "action": "UPDATE"
  },
  "eventType": evtType === 'submit'? "SUBMIT_CW_OVERRIDE": "FILE_CW_OVERRIDE",
  "eventTime": Date.now()
  }
  return HttpClient.custom({
    data: payload,
  })
}

export const insertInternalPSCReason  = eventMessage => {
  let body = {
    eventMessage: eventMessage,
    eventType: 'INSERT_REASON_FOR_PSC_SHIPMENT',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}

export const updateInternalPSCReason  = eventMessage => {
  let body = {
    eventMessage: eventMessage,
    eventType: 'UPDATE_PSC_REASON_FOR_SHIPMENT',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}

export const insertBillableReason  = eventMessage => {
  let body = {
    eventMessage: eventMessage,
    eventType: 'INSERT_AP_BILLABLE_REASON',
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data: body,
  })
}


export default {
  submitEntrySummaryForm,
  pscSubmitEntrySummaryForm,
  updateResponse,
  updateCRResponse,
  getCRValues,
  getBOLValues,
  getErrorMessages,
  searchJob,
  searchCurrentJob,
  resettingJob,
  updateWorkFlow,
  setAggregationView,
  fileAction,
  filePscAction,
  retractESForm,
  cargoReleaseStandalone,
  pgaUpdateSubmit,
  startPSC,
  startBhHouseJob ,
  bhSurrender,
  holdShipment,
  createArticleSetFromExistingLineItem,
  resetChildShipments,
  getAvailableOptions,
  sendMsgToRocketChat,
  CwOverride,
  entryNumberEdit,
  updateShipmentStatus,
  insertInternalPSCReason,
  updateInternalPSCReason,
  insertBillableReason
}
